
import React from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Control } from "react-hook-form";

interface QuoteTypeSelectorProps {
  control: Control<any>;
  isFirstQuote: boolean;
  isLoading: boolean;
  defaultQuoteType?: string;
  watchQuoteType: string;
}

const QuoteTypeSelector: React.FC<QuoteTypeSelectorProps> = ({
  control,
  isFirstQuote,
  isLoading,
  defaultQuoteType,
  watchQuoteType
}) => {
  if (isFirstQuote) {
    return null;
  }

  return (
    <FormField
      control={control}
      name="quoteType"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Quote Type</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            defaultValue={field.value}
            disabled={!!defaultQuoteType || isLoading}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select quote type" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="initial">Initial Quote</SelectItem>
              <SelectItem value="revised">Revised Quote</SelectItem>
              <SelectItem value="variation">Variation Quote</SelectItem>
            </SelectContent>
          </Select>
          <FormDescription>
            {watchQuoteType === 'revised' && "A revised quote replaces the previous quote"}
            {watchQuoteType === 'variation' && "A variation quote adds to or modifies the original scope"}
            {watchQuoteType === 'initial' && "The first quote for this booking"}
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default QuoteTypeSelector;
